<template>
  <div class="home">
    <el-container>
      <!-- 左边菜单导航 -->
      <el-aside width="none">
        <el-menu
          style="height: 100%"
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
          router
          unique-opened
        >
          <!-- logo -->
          <div class="menu-logo" @click="getHome">
            <img :src="logoUrl" />
          </div>

          <!-- 左菜单 -->
          <!-- 第一个循环 -->
          <el-submenu
            v-for="(item, index) in navmenu"
            :key="index"
            :index="item.title"
          >
            <template slot="title">
              <i :class="item.icon" style="color: #fff; "></i>
              <span slot="title">{{ item.title }}</span>
            </template>
            <!-- 第二个循环 -->
            <el-menu-item-group>
              <el-menu-item
                v-for="(itm, idx) in item.url"
                :key="idx"
                :index="itm.link"
                style="font-size: 12px"
                >
               <el-badge
                    :value="itm.count"
                    :hidden="itm.count=='0'"
                    :max="99"
                    class="itemBadge"
                  >{{ itm.name }}</el-badge>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header>
          <div class="header-content">
            <!-- 搜索 -->
            <div class="queryOrder">
              <el-input
                placeholder="请输入运单号"
                size="small"
                v-model.trim="input"
                clearable
                @keyup.enter.native="toOrderDetails"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="toOrderDetails"
                  :loading="loading"
                ></el-button>
              </el-input>
            </div>
            <!-- 右侧区域：用户信息和退出 -->
            <div class="header-right">
              <!-- 公司 -->
              <div class="user" @click="getHome">
                <i class="el-icon-s-custom"></i>{{ this.user || '加载中...' }}
              </div>
              <!-- 退出 -->
              <div class="sinout" @click="sinout">
                <i class="el-icon-switch-button"></i>
                退出
              </div>
            </div>
          </div>
        </el-header>
        <el-main>
          <tags-view />

           <section class="app-main" style="margin-top: 20px;">
                <transition name="fade-transform" mode="out-in">
                    <keep-alive :include="cachedViews">
                        <router-view :key="key" />
<!--                      <router-view  />-->
                    </keep-alive>
                </transition>
            </section>

        </el-main>
      </el-container>
    </el-container>




  </div>
</template>

<script>
//引入api
import httpApi from "@/http/api";
import { TagsView } from "../../src/components/layout"

export default {
  name: "Home",
  components: { TagsView },
  data() {
    return {
      navmenu: [
        {
          title: "订单管理",
          url: [
            // { link: "/expressorder", name: "快递下单" },            
            { link: "/products", name: "产品管理" },
            { link: "/orderby2", name: "新建订单" },
            { link: "/myorder", name: "头程订单" },
            { link: "/wcontainer", name: "尾程订单" },
          ],
          icon: "el-icon-folder-checked",
        },
        {
          title: "财务结算",
          url: [{ link: "/radingcenter", name: "交易记录" }],
          icon: "el-icon-money",
        },
        {
          title: "会员中心",
          url: [
            { link: "/supplier", name: "供应商管理" },
            { link: "/managementdef", name: "进口商管理" },
            { link: "/shippermanagement", name: "发货人管理" },
            { link: "/account", name: "账号管理" },
            { link: "/changepass", name: "修改密码" },
            { link: "/message", name: "公告" },
          ],
          icon: "el-icon-user",
        },
      ],
      input: "",
      user: "",
      logoUrl: "",
      loading: false,
    };
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  },
  methods: {
    //去往首页
    getHome() {
      this.$router.push("/");
    },
    //退出
    sinout() {
      sessionStorage.removeItem("token");
      localStorage.removeItem("refToken");
      this.$router.push("/login");
    },
    //获取公司
    getuser() {
      this.loading = true;
      httpApi.getUser()
        .then((res) => {
          if (res.data.code === "ok") {
            this.user = res.data.data.company;
          } else {
            this.$message.error(res.data.message || "获取用户信息失败");
          }
        })
        .catch((error) => {
          console.error("获取用户信息异常:", error);
          this.$message.error("获取用户信息失败，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    init() {
      const that = this;
      httpApi
        .listParams({
          params: {
            type: "sys_config",
            enable: "1",
          },
        })
        .then((res) => {
          if (res.data.code === "ok" && res.data.data && res.data.data.length > 0) {
            that.logoUrl = res.data.data[0].logoPortalUrl;
          } else {
            console.warn("获取系统配置失败或无数据");
          }
        })
        .catch((error) => {
          console.error("获取系统配置异常:", error);
        });
    },
    //搜索详情页
    toOrderDetails() {
      if (!this.input || !this.input.trim()) {
        this.$message.warning("请输入运单号");
        return;
      }
      
      this.loading = true;
      httpApi.search({ params: { clientNo: this.input.trim() } })
        .then((res) => {
          if (res.data.code === "ok") {
            const orderNo = res.data.data.findOrderResponse?.orderNo;
            if (orderNo) {
              this.$router.push("/orderdetails/" + orderNo);
            } else {
              this.$message.error("订单信息不完整");
            }
          } else {
            this.$message.error(res.data.message || "未找到该订单");
          }
        })
        .catch((error) => {
          console.error("搜索订单异常:", error);
          this.$message.error("搜索订单失败，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.init();
    this.getuser();
  },
};
</script>

<style lang="less" scoped>
// 布局容器
.home {
  width: 100%;
  height: 100%;
  position: absolute;
}
.el-container {
  height: 100%;
  width: 100%;
}
.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 60px;
}
.el-main {
  width: auto;
  min-width: 1000px;
  background-color: #fff !important;
  padding: 15px;
}
.el-aside {
  background-color: #545c64;
  color: #333;
  // text-align: center;
  line-height: 200px;
  height: 100%;
  /deep/ .menu-logo {
    cursor: pointer;
    height: 70px;
    background-color: #fff;
    display: flex;
    img {
      margin: auto;
      height: 80%;
      width: auto;
    }
  }
  /deep/.el-menu-item-group__title {
    padding: 3px 0 3px 20px;
  }
  /deep/.el-submenu__title {
    padding: 0 60px 0 0px;
    /deep/.el-icon-menu {
      padding: 0 15px 0 0px;
    }
  }
  /deep/.el-menu {
    border-right: none;
  }
}
/deep/.el-submenu .el-menu-item {
  min-width: 180px !important;
}
.el-header {
  background: url("../assets/bg1.png") no-repeat 100% 100%;
  height: 70px !important;
  line-height: 70px;
  padding: 0 20px;
  
  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    max-width: 100%;
  }
  
  .header-right {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  
  .sinout {
    cursor: pointer;
    text-align: center;
    color: #fff;
    display: flex;
    align-items: center;
    gap: 5px;
    white-space: nowrap;
    i {
      font-size: 14px;
    }
  }
  
  .queryOrder {
    width: 200px;
    flex-shrink: 0;
  }
  
  .user {
    font-size: 14px;
    cursor: pointer;
    color: white;
    height: 70px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    i {
      font-size: 14px;
      margin-right: 5px;
    }
  }
}

// 平板适配
@media (max-width: 1024px) {
  .el-header {
    padding: 0 15px;
    
    .header-content {
      flex-wrap: wrap;
    }
    
    .queryOrder {
      width: 180px;
    }
    
    .header-right {
      gap: 10px;
    }
    
    .user {
      font-size: 13px;
      max-width: 200px;
    }
  }
  
  .el-main {
    min-width: 100%;
    padding: 10px;
  }
}

// 平板和小屏幕适配
@media (max-width: 768px) {
  .el-header {
    padding: 0 10px;
    
    .header-content {
      gap: 10px;
    }
    
    .queryOrder {
      width: 150px;
    }
    
    .header-right {
      gap: 8px;
    }
    
    .user {
      font-size: 12px;
      max-width: 120px;
    }
    
    .sinout span {
      display: none;
    }
  }
  
  .el-aside {
    width: auto !important;
  }
  
  /deep/.el-submenu .el-menu-item {
    min-width: 150px !important;
    font-size: 11px;
  }
}
</style>
